import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { Event } from '../types';
import EventDescription from './EventDescription';
import StatusBadge from './StatusBadge';

type EventCardProps = {
  event: Event;
  onClick?: (event: Event) => void;
  showStatus?: boolean;
};

const EventCard = ({ event, onClick, showStatus = true }: EventCardProps) => {
  const interactive = Boolean(onClick);

  return (
    <article
      className={`card bg-onyx border-0 shadow-lg event-card ${interactive ? 'event-card-button' : ''}`}
      onClick={interactive ? () => onClick?.(event) : undefined}
      role={interactive ? 'button' : undefined}
    >
      <div className="card-body p-4">
        <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
          <div>
            <p className="text-white-50 small mb-2">{event.institution}</p>
            <h5 className="text-white mb-1">{event.title}</h5>
            <p className="text-white-50 mb-0">{event.promoter}</p>
          </div>
          {showStatus && <StatusBadge kind="event" status={event.status} />}
        </div>

        <EventDescription
          description={event.description}
          format={event.descriptionFormat}
          compact
        />

        <div className="event-meta">
          <div>
            <span className="text-white">Data</span>
            <small className="d-block text-white-50">
              {format(new Date(event.startAt), "dd 'de' MMMM, HH:mm", { locale: ptBR })}
            </small>
          </div>
          <div>
            <span className="text-white">Local</span>
            <small className="d-block text-white-50">{event.location}</small>
          </div>
          <div>
            <span className="text-white">Público</span>
            <small className="d-block text-white-50">{event.targetAudience}</small>
          </div>
          <div>
            <span className="text-white">Estimativa</span>
            <small className="d-block text-white-50">{event.estimatedAudience || 'Não informada'}</small>
          </div>
          <div>
            <span className="text-white">Acesso</span>
            <small className="d-block text-white-50">
              {event.accessType === 'ingressos' ? 'Ingressos' : 'Aberto'}
            </small>
          </div>
        </div>
      </div>
    </article>
  );
};

export default EventCard;
